import FormatSizeIcon from '@mui/icons-material/FormatSize';
import { InputAdornment, MenuItem, Select } from '@mui/material';
import { type EdgeProps, useReactFlow } from '@xyflow/react';
import { FlowStickyNoteFontSize } from 'flow-schema';
import { useId } from 'react';

import { type ReactFlowStickyNoteNode } from '../../../../../types';
import { type ReactFlowStickyNoteNodeProps } from '../../BlockType/types';

export function StickyNoteToolbarFontSelect(props: ReactFlowStickyNoteNodeProps) {
  const {
    id: nodeId,
    data: { fontSize },
  } = props;
  const { updateNodeData } = useReactFlow<ReactFlowStickyNoteNode, EdgeProps>();
  const selectId = useId();
  return (
    <Select
      id={selectId}
      value={fontSize || FlowStickyNoteFontSize.Medium}
      onChange={(event) => {
        updateNodeData(nodeId, {
          fontSize: event.target.value,
        });
      }}
      size="small"
      startAdornment={
        <InputAdornment position="start">
          <FormatSizeIcon fontSize="small" />
        </InputAdornment>
      }
      variant="outlined"
      sx={{
        '& fieldset': { border: 'none', boxShadow: 'none' },
      }}
    >
      {Object.values(FlowStickyNoteFontSize).map((fontSize) => {
        return (
          <MenuItem
            key={fontSize}
            value={fontSize}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {fontSize}
          </MenuItem>
        );
      })}
    </Select>
  );
}
